import { cookieConstants } from './cookie-constants';
import { getTodayAsDate } from '../components/utils/date-utils';

const COOKIE_DOMAIN = window.appState.ssoConfig.cookieStorage.domain;

export function setCookie(cookieName, cookieValue) {
    document.cookie = `${cookieName}=${cookieValue};path=/`;
}

export function setCookiOnDomain(cookieName, cookieValue) {
    document.cookie = `${cookieName}=${cookieValue};domain=${COOKIE_DOMAIN};path=/`;
}

export function setCookieWithExpirationDate(cookieName, cookieValue, expirationTimeInMinutes, secure = false) {
    const currentDate = getTodayAsDate();
    const newDateMinutes = currentDate.getMinutes() + expirationTimeInMinutes;
    currentDate.setMinutes(newDateMinutes);
    const dateAsString = currentDate.toUTCString();
    document.cookie = `${cookieName}=${cookieValue};expires=${dateAsString};secure=${secure}`;
}

export function removeCookie(cookieName) {
    document.cookie = `${cookieName}=;expires=${cookieConstants.OLD_COOKIE_EXPIRATION_DATE}`;
}

export function getCookie(cookieName) {
    // Split cookie string and get all individual name=value pairs in an array
    const cookieArr = document.cookie.split(';');

    // Loop through the array elements
    for (let i = 0; i < cookieArr.length; i++) {
        const cookiePair = cookieArr[i].split('=');

        /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
        if (cookieName === cookiePair[0].trim()) {
            // Decode the cookie value and return
            return decodeURIComponent(cookiePair[1]);
        }
    }

    // Return null if not found
    return null;
}
